import classnames from 'classnames';
import { browserHistory } from 'react-router';

import styles from './Button.scss';

const SIZE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
};

const COLOR = {
    BLACK: 'text--black',
    WHITE: 'text--white',
    RED: 'text--red',
    BLUE: 'text--blue',
    GREY: 'text--grey',
    GREY7: 'text--grey7',
    GREYAlt: 'text--greyAlt',
};

const BGCOLOR = {
    ORANGE: 'bg--orange',
    BLUE: 'bg--blue',
    CLEAR: 'bg--clear',
    DARKGREY: 'bg--darkGrey',
    MEDIUMGREY: 'bg--mediumGrey',
    LIGHTGREY: 'bg--lightGrey',
    RED: 'bg--red',
    GREY7: 'bg--grey7',
};

const OUTCOLOR = {
    ORANGE: 'outlined--orange',
    BLUE: 'outlined--blue',
    NONE: 'outlined--none',
    GREY: 'outlined--grey',
    DARKGREY: 'outlined--darkGrey',
    MEDIUMGREY: 'outlined--mediumGrey',
    LIGHTGREY: 'outlined--lightGrey',
    ALTGREY: 'outlined--greyAlt',
    RED: 'outlined--red',
};

export const BUTTON = {
    SIZE,
    COLOR,
    BGCOLOR,
    OUTCOLOR,
};

export function Button({
    onClick,
    text,
    color = COLOR.GREY,
    bgcolor = BGCOLOR.CLEAR,
    type = SIZE.PRIMARY,
    outline = OUTCOLOR.NONE,
    disabled,
    className,
    to,
    prefixIcon = null,
    postfixIcon = null,
    children,
    defaultStyle,
    style = null
}) {
    const classes = classnames(className, {
        [styles[type]]: !defaultStyle,
        [styles[bgcolor]]: !defaultStyle,
        [styles[color]]: !defaultStyle,
        [styles[outline]]: !defaultStyle,
    });

    return (
        <button
            style={style}
            className={classes}
            disabled={disabled}
            onClick={(e) => {
                if (onClick) onClick(e);
                if (to) browserHistory.push(to);
            }}
            data-cy={text ? 'Button-' + text : 'Button-' + children}
        >
            {prefixIcon}
            {children || text}
            {postfixIcon}
        </button>
    );
}
